import React, { useContext } from 'react';
import Logo from '../../Assets/Images/logo.png';
import Sidebar from '../../Assets/Images/sidebar.svg';
import Profile from '../../Assets/Images/profile.png';
import '../../App.scss'

import UserContext from '../../store/UserContext';

const Header =() => {
	
	const userCtx = useContext(UserContext);

  const showHeaderDetails = () => {
    if (window.location.href.indexOf('simulate') !== -1) {
      return "Simulation";
    }
    if (userCtx.alertCancelled && userCtx.name) {
      return `Triggered by ${userCtx.name}`;
    }
    return userCtx.name ? `${userCtx.name} is Panicking` : null;
  };

  const headerText = showHeaderDetails();
  
  return (
    <>
      <header>
        {/* <img src={Sidebar}  className="sidebar" /> */}
        <img src={Logo} className="logo" />
        <div className="profile">{ headerText }</div>
      </header>
      {
        window.location.href.indexOf('simulate') !== -1 ? (
          <div className='warning-simulate'>
            <span>You are currently viewing a simulation of the Live Location Tracker</span>
          </div>
        ) : null
      }
    </>
  )
  
}

export default Header;